export enum EditorMode {
    List,
    Create,
    Edit
}

export enum CreatorMode {
    Main,
    SetupRoles,
    SetupRoleRow,
    SetupSingleRoleRow,
    CustomizeRoles,
}